import axios from 'axios';
const BASE = 'https://ouresign.com/api';
const client = axios.create({ baseURL: BASE });
client.interceptors.request.use(config => {
  const token = localStorage.getItem('admin_token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});
client.interceptors.response.use(res => res, err => {
  // Only logout on 401 if it's not a staff edit/delete/OTP action
  const url = err.config?.url || '';
  const isStaffAction = url.includes('/staff/') || url.includes('/reset-pin') || url.includes('/affiliate/');
  if (err.response?.status === 401 && !isStaffAction) {
    localStorage.clear();
    window.location.href = '/login';
  }
  return Promise.reject(err);
});
export default client;
